import {CraVariableSchema, WatchlistListsEditorModel, WatchlistType} from "../../../../domain/cra/CraDomains";
import {Dispatch, SetStateAction, useEffect, useState} from "react";
import ServiceContainer from "../../../../config/ServiceContainer";
import {ServiceNames} from "../../../../constant/ServiceNames";
import WatchlistService from "../../../../service/WatchlistService";
import {SelectButton} from "primereact/selectbutton";
import {WatchlistListsModel} from "../../../../domain/watchlist/WatchlistDomains";
import SourceListComponent from "./SourceListComponent";
import CustomLoading from "../../../../components/custom/CustomLoading";

export function ListComponent(
  {
    selectedWatchlistType = WatchlistType.GENERAL,
    variable,
    setVariable
  }: ListComponentProps
) {

  const watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  const [watchlistType, setWatchlistType] = useState<WatchlistType>(selectedWatchlistType);
  const [watchlist, setWatchlist] = useState<WatchlistListsEditorModel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const options = [
    {label: 'General', value: WatchlistType.GENERAL},
    {label: 'Individual', value: WatchlistType.INDIVIDUAL},
    {label: 'Entity', value: WatchlistType.ENTITY}
  ];

  useEffect(() => {
    setLoading(true);
    watchlistService.getLists().then((list) => {
      const watchlistResponse: WatchlistListsEditorModel[] = list.map((item: WatchlistListsModel) => ({
        ...item,
        isEnabled: (variable.lists && variable.lists.length > 0) ? variable.lists?.includes(item.id) : true
      }));
      setWatchlist(watchlistResponse);
      setLoading(false);
    }).catch((error) => {
      console.error("Error fetching watchlist lists:", error);
    });
  }, [watchlistType]);

  const onToggle = (id: string, value: boolean) => {
    setWatchlist((prevWatchlist) => {
      const watchlist = prevWatchlist.map((item) =>
        item.id === id ? {...item, isEnabled: value} : item
      )
      setVariable({...variable, watchlistType: watchlistType, lists: watchlist.filter((item) => item.isEnabled).map((item) => item.id)});
      return watchlist
    })
    ;
  }

  return (
    <div>
      <SelectButton
        value={watchlistType}
        onChange={(e) => setWatchlistType(e.value)}
        options={options}
        unselectable={false}
        className="w-full"/>
      {loading ?
        <CustomLoading/> : <SourceListComponent watchlistResponse={watchlist} onToggle={onToggle}/>}
    </div>
  )
}

export interface ListComponentProps {
  selectedWatchlistType?: WatchlistType;
  variable: CraVariableSchema;
  setVariable: Dispatch<SetStateAction<CraVariableSchema>>;
}